<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Construction Equipment Icon -->
        <path
            d="M19 7H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V7H5C3.9 7 3 7.9 3 9V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V9C21 7.9 20.1 7 19 7ZM10 4H14V7H10V4ZM19 20H5V9H19V20Z"
            fill="currentColor"
        />
        <!-- Tool/Equipment Detail -->
        <rect x="7" y="11" width="10" height="2" rx="1" fill="currentColor" />
        <rect x="7" y="15" width="10" height="2" rx="1" fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: 'EquipmentIcon'
};
</script>
